import { render, staticRenderFns } from "./CanvasCrackSingleDesign.vue?vue&type=template&id=0b98138d&scoped=true&"
import script from "./CanvasCrackSingleDesign.vue?vue&type=script&lang=js&"
export * from "./CanvasCrackSingleDesign.vue?vue&type=script&lang=js&"
import style0 from "./CanvasCrackSingleDesign.vue?vue&type=style&index=0&id=0b98138d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98138d",
  null
  
)

export default component.exports